import React, { useState } from "react";
import { useEffect } from "react";
import { X } from "react-feather";
import { MdSearch } from "react-icons/md";
import { useIntl } from "react-intl";
import { getEmpreendimentos, saveGlebaEmpreendimento } from "~/api";
import DatePicker from "~/components/DatePicker";
import useDebounce from "~/hooks/useDebounce";
import "./styles.scss";

const AddProductSicorModal = ({ onClose, glebaId, onSuccess }) => {
  const [searchParam, setSearchParam] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedCode, setSelectedCode] = useState(null);
  const [isAddingDates, setIsAddingDates] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [dates, setDates] = useState({
    inicioPlantio: "",
    fimPlantio: "",
    inicioColheita: "",
    fimColheita: ""
  });

  const { formatMessage } = useIntl();

  const searchHandler = useDebounce(value => {
    setSearchParam(value);
  }, 500);

  useEffect(() => {
    if (searchParam.length <= 2) return;

    setIsLoading(true);
    getEmpreendimentos(searchParam).then(res => {
      setProducts(res.data.result);
      setIsLoading(false);
    });
  }, [searchParam]);

  const handleChangeDates = (name, val) => {
    setDates(oldDates => ({
      ...oldDates,
      [name]: val
    }));
  };

  const registerProduct = () => {
    if (!selectedCode || isSaving) return;
    setIsSaving(true);

    const selectedProduct = products.find(
      product => product.BacenEmpreendimento.codigo === selectedCode
    );

    const hasDateSet = Object.keys(dates).some(key => !!dates[key]);

    const data = {
      b3_proposta_gleba_id: glebaId,
      bacen_empreendimento_id: selectedProduct.BacenEmpreendimento.id,
      detalhes_json: hasDateSet ? JSON.stringify(dates) : null
    };

    saveGlebaEmpreendimento(data).then(() => {
      onSuccess();
      setIsSaving(false);
    });
  };

  const selectedProduct = products.find(
    product => product.BacenEmpreendimento.codigo === selectedCode
  );

  return (
    <>
      <div className="modal add-sicor-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "cadastrar-produto-sicor" })}
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          <section className="modal-card-body">
            <p className="modal-description">
              {formatMessage({ id: "pesquise-caixa-abaixo" })}
            </p>

            <div className="search-input">
              <MdSearch size={20} />
              <input
                type="text"
                placeholder={formatMessage({ id: "pesquise-codigo-nome" })}
                onChange={e => searchHandler(e.target.value)}
              />
            </div>

            <table className="table is-hoverable">
              <thead className={`${products.length > 4 ? "has-scroll" : ""}`}>
                <tr>
                  <th>{formatMessage({ id: "codigo" })}</th>
                  <th>{formatMessage({ id: "nome" })}</th>
                  <th>{formatMessage({ id: "finalidade" })}</th>
                  <th>{formatMessage({ id: "atividade" })}</th>
                  <th>{formatMessage({ id: "modalidade" })}</th>
                </tr>
              </thead>
              <tbody>
                {products.length === 0 && (
                  <tr className="no-products">
                    <td>
                      {formatMessage({ id: "digite-produto-acima-resultados" })}
                    </td>
                  </tr>
                )}
                {products.map((product, productIndex) => {
                  const emp = product.BacenEmpreendimento;

                  return (
                    <tr
                      key={productIndex}
                      className={
                        emp.codigo === selectedCode ? "is-selected" : ""
                      }
                      onClick={() => setSelectedCode(emp.codigo)}
                    >
                      <td>{emp.codigo}</td>
                      <td>{emp.produto}</td>
                      <td>{emp.finalidade}</td>
                      <td>{emp.atividade}</td>
                      <td>{emp.modalidade}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            <div className="">
              {isLoading && <div className="loader"></div>}
            </div>

            {selectedProduct && (
              <div className="product-details">
                <p className="product-details-header">
                  {formatMessage({ id: "detalhes-produto" })}
                </p>

                <div className="product-details-grid">
                  <p>
                    <strong>{formatMessage({ id: "codigo" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.codigo}
                  </p>
                  <p>
                    <strong>{formatMessage({ id: "finalidade" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.finalidade}
                  </p>
                  <p>
                    <strong>{formatMessage({ id: "nome" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.produto}
                  </p>
                  <p>
                    <strong>{formatMessage({ id: "atividade" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.atividade}
                  </p>
                  <p>
                    <strong>{formatMessage({ id: "modalidade" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.modalidade}
                  </p>
                  <p>
                    <strong>{formatMessage({ id: "variedade" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.variedade}
                  </p>
                  <p>
                    <strong>{formatMessage({ id: "cesta" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.cesta}
                  </p>
                  <p>
                    <strong>{formatMessage({ id: "zoneamento" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.zoneamento}
                  </p>
                  <p>
                    <strong>{formatMessage({ id: "consorcio" })}:</strong>{" "}
                    {selectedProduct.BacenEmpreendimento.consorcio}
                  </p>
                </div>
              </div>
            )}

            {isAddingDates && (
              <div className="product-details">
                <p className="product-details-header">Datas</p>

                <div className="product-details-grid">
                  <label htmlFor="">
                    {formatMessage({ id: "data-inicio-plantio" })}
                    <DatePicker
                      onChange={date =>
                        handleChangeDates("inicioPlantio", date)
                      }
                    />
                  </label>
                  <label htmlFor="">
                    {formatMessage({ id: "data-inicio-colheita" })}
                    <DatePicker
                      onChange={date =>
                        handleChangeDates("inicioColheita", date)
                      }
                    />
                  </label>
                  <label htmlFor="">
                    {formatMessage({ id: "data-fim-plantio" })}
                    <DatePicker
                      onChange={date => handleChangeDates("fimPlantio", date)}
                    />
                  </label>
                  <label htmlFor="">
                    {formatMessage({ id: "data-fim-colheita" })}
                    <DatePicker
                      onChange={date => handleChangeDates("fimColheita", date)}
                    />
                  </label>
                </div>
              </div>
            )}

            {isAddingDates && (
              <button
                className="product-button remove-dates-button"
                onClick={() => setIsAddingDates(false)}
              >
                {formatMessage({ id: "remover-datas" })}
              </button>
            )}

            {selectedProduct && !isAddingDates && (
              <button
                className="product-button add-dates-button"
                onClick={() => setIsAddingDates(true)}
              >
                {formatMessage({ id: "adicionar-datas-opcional" })}
              </button>
            )}

            <button
              className={`product-button add-button ${
                selectedProduct && !isSaving ? "" : "disabled"
              }`}
              onClick={registerProduct}
            >
              {formatMessage({ id: "cadastrar-produto" })}
            </button>
          </section>
        </div>
      </div>
    </>
  );
};

export default AddProductSicorModal;
